"use strict";
exports.__esModule = true;
exports.SvgPlay = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgPlay = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "currentColor", d: "M18.023 12.933l-9.857 6.878a1.042 1.042 0 01-1.486-.31 1.166 1.166 0 01-.18-.623V5.122C6.5 4.502 6.98 4 7.572 4c.211 0 .418.066.594.188l9.857 6.879c.492.343.625 1.04.297 1.555-.079.123-.18.23-.297.311z" }),
        react_1["default"].createElement("path", { d: "M0 0h24v24H0z" })))); };
//# sourceMappingURL=Play.js.map